import styled from "styled-components";

interface IProps {
  color?: React.CSSProperties["color"];
  background?: React.CSSProperties["background"];
}
export const Styles = styled.div<IProps>`
  .ant-radio-disabled .ant-radio-inner {
    border-color: ${(props) => (props.color ? props.color : "")};
    &::after {
      background: ${(props) => (props.color ? props.color : "")};
    }
  }
  .ant-form-item-control {
    background: ${(props) =>
      props.background ? `${props.background} !important` : "#fff"};
    .ant-radio-disabled + span {
      color: ${(props) => (props.color ? props.color : "")};
    }
  }
`;
